module.exports = __webpack_public_path__ + "static/img/error-404.94756dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error-page/error-404.svg
// module id = jAYZ
// module chunks = 1